import { Badge, Calendar } from "antd";
import moment from "moment";
import React, { FC, useEffect, useState } from "react";
import "./index.scss";

import FullCalendar, {
  EventApi,
  DateSelectArg,
  EventClickArg,
  EventContentArg,
  formatDate,
} from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from "@fullcalendar/rrule";
import AddEventModal from "components/Modals/AddEventModal";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_SCHEDULE } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";

import { EventInput } from "@fullcalendar/react";

let eventGuid = 0;

export function createEventId() {
  return String(eventGuid++);
}

// const events = [
//   { date: "2021-12-12" },
//   { date: "2021-12-18" },
//   { date: "2021-12-11" },
//   { date: "2021-12-15" },
//   { date: "2021-11-28" },
//   { date: "2021-12-21" },
//   { date: "2021-12-09" },
// ];

// function dateCellRender(value: moment.Moment) {
//   return (
//     <div className="events">
//       {events.find((event) => value.isSame(moment(event.date), "day")) ? (
//         <Badge status="success" />
//       ) : (
//         <span></span>
//       )}
//     </div>
//   );
// }

// const dateCellRender = (value: Moment) => {
//   const listData = getListData(value);
//   return (
//     <ul className="events">
//       {listData.map(item => (
//         <li key={item.content}>
//           <Badge status={item.type as BadgeProps['status']} text={item.content} />
//         </li>
//       ))}
//     </ul>
//   );
// };

const EventCalendarPreview: FC<{ theme?: any }> = ({ theme }) => {
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState<any>();
  const [currentEvents, setCurrentEvents] = useState([]);
  const { userSchedule } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userSchedule) {
      console.log('user schedule', userSchedule);
      const parsedEvents = [];
      userSchedule.map((schedule) => {
        let event = schedule.info.calendar;
        let start = new Date(event.dateTime);
        // let time = new Date(event.time);
        // start.setHours(time.getHours());
        // start.setMinutes(time.getMinutes());
        parsedEvents.push({
          ...event,
          objectId: schedule.objectId,
          title: `${event.title}`,
          id: createEventId(),
          start,
          rrule: event.repeat
            ? {
                freq: event.repeatFrequency,
                interval: event.repeatAfter,
                dtstart: start,
                until:
                  event.repeatUntil
                    ? new Date(event.repeatUntil)
                    : undefined,
              }
            : undefined,
        });
      });
      setCurrentEvents(parsedEvents);
    }
  }, [userSchedule]);

  const handleDateSelect = (selectInfo: DateSelectArg) => {
    let title = prompt("Please enter a new title for your event");
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: new Date().getTime().toString(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay,
      });
    }
  };

  const handleEventClick = (clickInfo: EventClickArg) => {
    // if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    // clickInfo.event.remove()
    // }
    const event = clickInfo.event.toPlainObject();
    setSelectedEvent({
      ...event.extendedProps,
      title: event.title,
      date: event.start,
    });
  };

  const handleEvents = (events: EventApi[]) => {
    // this.setState({
    //   currentEvents: events
    // })
    console.log("handle events here", events);
  };

  const renderEventContent = (eventContent: EventContentArg) => {
    return (
      <>
        <b>{eventContent.timeText}</b>
        <i>{eventContent.event.title}</i>
      </>
    );
  };

  return (
    <div className="clock">
      {/* <Calendar dateCellRender={dateCellRender} fullscreen={true} /> */}

      <div>
        {/* {renderSidebar()} */}
        <div>
          <FullCalendar
            plugins={[
              rrulePlugin,
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
            ]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={weekendsVisible}
            // initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
            events={currentEvents}
            select={handleDateSelect}
            eventContent={renderEventContent} // custom render function
            eventClick={handleEventClick}
            eventsSet={handleEvents} // called after events are initialized/added/changed/removed
            /* you can update a remote database when these fire:
            eventAdd={function(){}}
            eventChange={function(){}}
            eventRemove={function(){}}
            */
          />
        </div>
      </div>

      {selectedEvent && (
        <AddEventModal
          onClose={() => setSelectedEvent(undefined)}
          eventObj={selectedEvent}
          id={selectedEvent.eventId}
        />
      )}
    </div>
  );
};
export default EventCalendarPreview;
